import type { RecognitionHint } from '@capture/shared';

interface Props {
  hints: RecognitionHint[];
  onChange: (hints: RecognitionHint[]) => void;
}

export function HintsEditor({ hints, onChange }: Props) {
  function addHint() {
    const next: RecognitionHint = {
      id: crypto.randomUUID(),
      kind: 'keyword',
      value: '',
    };
    onChange([...hints, next]);
  }

  function removeHint(id: string) {
    onChange(hints.filter((h) => h.id !== id));
  }

  function updateHint(id: string, patch: Partial<RecognitionHint>) {
    onChange(
      hints.map((h) => (h.id === id ? { ...h, ...patch } : h)),
    );
  }

  return (
    <div className="hints-editor">
      <h3 className="hints-editor__title">RECOGNITION HINTS</h3>
      {hints.map((hint) => (
        <div key={hint.id} className="hints-editor__row">
          <select
            className="hints-editor__select"
            value={hint.kind}
            onChange={(e) =>
              updateHint(hint.id, {
                kind: e.target.value as RecognitionHint['kind'],
              })
            }
          >
            <option value="keyword">keyword</option>
            <option value="phrase">phrase</option>
            <option value="header-field">header-field</option>
          </select>
          <input
            className="hints-editor__input"
            value={hint.value}
            onChange={(e) => updateHint(hint.id, { value: e.target.value })}
            placeholder="Hint value"
          />
          <input
            className="hints-editor__weight"
            type="number"
            value={hint.weight ?? ''}
            onChange={(e) =>
              updateHint(hint.id, {
                weight: e.target.value ? Number(e.target.value) : undefined,
              })
            }
            placeholder="Weight"
            step={0.1}
            min={0}
            max={1}
          />
          <button
            type="button"
            className="hints-editor__remove"
            onClick={() => removeHint(hint.id)}
          >
            Remove
          </button>
        </div>
      ))}
      <button
        type="button"
        className="hints-editor__add"
        onClick={addHint}
      >
        + Add hint
      </button>
    </div>
  );
}
